/**
 * External dependencies
 */
import React, { useRef, forwardRef } from 'react';
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const faIconPrefix = {
    regular: 'far',
    solid: 'fas',
};

const Icon = forwardRef(({ size, color = 'currentColor', name, type = 'regular', style, ...props }, ref) => {
    if (!name) {
        return null;
    }

    const iconLookup = { prefix: faIconPrefix[type], iconName: name };
    const iconDefinition = findIconDefinition(iconLookup);

    return (
        <FontAwesomeIcon
            icon={iconDefinition}
            style={{ fontSize: size && size, color, ...style }}
            {...props}
            ref={ref}
        />
    );
});

export default Icon;
